import React from 'react';

import CompanyDetails from '../../components/Admin/CompanyDetails';

function CompanyDetailsView() {
  return (
    <CompanyDetails />
  );
}

export default CompanyDetailsView;
